import * as actionTypes from '../actionsTypes';
import { ILocation } from '../models/ILocation';
import { IActuatorState } from '../models/types';

const initialActuatorState: IActuatorState = {
    actuators: [],
    locations: []
};

export const actuators = (state: IActuatorState = initialActuatorState, action: any): IActuatorState => {
    switch (action.type) {

        case actionTypes.ACTUATOR_LIST:
            // let arr = [];
            // for (let a in action.payload) {
            //     arr.push(action.payload[a] as IActuator);
            // }
            console.log('reducer refreshing actuators')
            return {
                ...state,
                actuators: action.payload //arr
            };
        case actionTypes.ACTUATOR_LOCATION_LIST:
            // debugger;
            let arr = [];
            for (let a in action.payload) {
                arr.push(action.payload[a] as ILocation);
            }
            return {
                ...state,
                locations: arr
            };
        // return state;

        default: {
            return state;
        }
    }
};